import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { _ as _objectSpread2 } from '../../../dist/objectSpread2-811c5212.esm.js';
import _typeof from '@babel/runtime/helpers/esm/typeof';

var init = function init() {
  var intersectionOptions = {
    threshold: 0.5
  };
  var trackComponent = function trackComponent(eventGrouping, eventName, eventData, trackProps) {
    var additionalTrackProps = {
      event_name: eventName
    };
    if (eventData) {
      for (var key in eventData) {
        if (_typeof(eventData[key]) === 'object') {
          console.warn('Please do not nest objects in eventData as it is difficult to parse');
        }
      }
      additionalTrackProps.event_data = JSON.stringify(eventData);
    }
    return window.nerdalytics.track(eventGrouping, _objectSpread2(_objectSpread2({}, trackProps), additionalTrackProps));
  };
  var handleIntersection = function handleIntersection(entries, observer) {
    entries.filter(function (entry) {
      return entry.isIntersecting && entry.intersectionRatio >= intersectionOptions.threshold;
    }).forEach(function (entry) {
      var trackingProps = JSON.parse(entry.target.getAttribute('data-component-tracking'));
      trackComponent('Static Component Event', 'viewed', undefined, trackingProps);
      observer.unobserve(entry.target);
    });
  };
  var observer = new IntersectionObserver(handleIntersection, intersectionOptions);
  var components = _toConsumableArray(document.querySelectorAll('[data-component-tracking]'));
  components.forEach(function (component) {
    // Disable 'Component Loaded' events whilst perf is a concern
    // const trackingProps = JSON.parse(component.getAttribute('data-component-tracking'))
    // trackComponent('Static Component Event', 'loaded', undefined, trackingProps)
    observer.observe(component);
  });
};

export { init as default };
